import { forwardRef } from 'react'
import { CopyToClipboardProps } from './types'
import { useStyles } from './styles'
import { getTheme, toast } from '@conexasaude/conexa-hero'
import { Icon } from '@conexasaude/iconography/icons'

const CopyToClipboard = forwardRef<HTMLInputElement, CopyToClipboardProps>(
  (props, ref) => {
    const { sx, onActionClick, ...rest } = props
    const styles = useStyles()
    const theme = getTheme()
    const onCopy = () => {
      navigator.clipboard.writeText(rest.value.toString()).then(() => {
        toast({
          message: 'Link copiado para a área de transferência',
          variant: 'success',
        })
      })

      onActionClick?.()
    }

    return (
      <div css={[styles.root, sx?.root || null]}>
        <input ref={ref} css={[styles.input, sx?.input || null]} {...rest} />

        <button onClick={onCopy} css={[styles.button, sx?.button || null]}>
          <Icon name="copy" color={theme.colors.background.white} />
        </button>
      </div>
    )
  },
)

CopyToClipboard.displayName = 'CopyToClipboard'

export { CopyToClipboard }
